import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import BaseLink from "~/components/links/BaseLink";

const MobileSecondaryNavLink = styled(BaseLink)`
    font-size: 1.6rem;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.black};
    padding-bottom: 15px;
`;

const MobileSecondary = ({ linkLabel, linkUrl, index, navLength }) => {
    const mobileSecondaryNavLinkProps = {
        to: linkUrl,
    };

    if (index === navLength) {
        mobileSecondaryNavLinkProps.tagLabel = `${linkLabel}-Last`;
    }

    return (
        <MobileSecondaryNavLink {...mobileSecondaryNavLinkProps}>
            {linkLabel}
        </MobileSecondaryNavLink>
    );
};

MobileSecondary.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    navLength: PropTypes.number.isRequired,
};

export default MobileSecondary;
